import {
	createContext,
	useReducer,
	type Dispatch,
	type FC,
	type HTMLAttributes,
	type PropsWithChildren,
	type Reducer,
} from "react";

import LocalStorage from "../../../utils/local-storage";
import * as s from "./Accordion.module.scss";

type AccordionProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

type AccordionState = Record<string, boolean>;

type AccordionAction = {
	type: "setOpen";
	key: keyof AccordionState;
};

const accordionReducer: Reducer<AccordionState, AccordionAction> = (
	state,
	action,
) => {
	switch (action.type) {
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		case "setOpen": {
			LocalStorage.set(
				"accordionData",
				JSON.stringify({
					...state,
					[action.key]: !state[action.key],
				}),
			);

			return {
				...state,
				[action.key]: !state[action.key],
			};
		}
		default: {
			return state;
		}
	}
};

export const AccordionContext = createContext<
	[AccordionState, Dispatch<AccordionAction>]
>([JSON.parse(LocalStorage.get("accordionData") || "{}") || {}, () => ({})]);

const Accordion: FC<AccordionProps> = ({ children, ...props }) => {
	const [state, dispatch] = useReducer(accordionReducer, {});

	return (
		<AccordionContext.Provider value={[state, dispatch]}>
			<div className={s.container} {...props}>
				{children}
			</div>
		</AccordionContext.Provider>
	);
};

export default Accordion;
